import { createSlice } from "@reduxjs/toolkit";

const locateFamilySlice = createSlice({
    name: "locateFamilySetup",
    initialState: {
      locateFamilyData: null,
    },
    reducers: {
      setLocateFamilyData: (state, action) => {
        state.locateFamilyData = action?.payload
      },
      clearLocateFamily: (state, action) => {
        state.locateFamilyData = null
      }
    }
  });


// this is for dispatch
export const { locateFamilyData, clearLocateFamily } = locateFamilySlice.actions;

// this is for configureStore
export default locateFamilySlice.reducer;